import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { capitalize, startCase } from 'lodash-es';
import { AllWasteTypesGQL, Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnChanges,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { DetailsBoxComponent } from '../details-box';

import { WasteType } from './waste-type.types';

@Component({
  selector: 'wo-waste-type',
  templateUrl: './waste-type.component.html',
  styleUrls: [ './waste-type.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    DetailsBoxComponent,
  ],
})
export class WasteTypeComponent implements OnChanges {
  private readonly all$ = inject(AllWasteTypesGQL).watch({ includeInactive: true }).valueChanges.pipe(
    filter(({ data }) => Boolean(data)),
    map(({ data }) => data.wasteTypes),
  );

  public presentedName$!: Observable<Maybe<WasteType['ewcCode']>>;
  public ewcCode$!: Observable<Maybe<WasteType['ewcCode']>>;

  @Input() public code: Maybe<WasteType['wasteTypeCode']>;
  @Input() public ewcCode: Maybe<WasteType['ewcCode']>;
  @Input() public name: Maybe<WasteType['presentedName']>;

  public ngOnChanges(): void {
    const waste$ = this.code
      ? this.all$.pipe(map(wasteTypes => wasteTypes.find(wasteType => wasteType.wasteTypeCode === this.code)))
      : of(undefined);

    this.ewcCode$ = this.ewcCode
      ? of(this.ewcCode)
      : waste$.pipe(map(waste => waste?.ewcCode));

    this.presentedName$ = this.name
      ? of(this.name)
      : waste$.pipe(map(waste => waste?.presentedName || this.fallbackName));
  }

  private get fallbackName(): string | undefined {
    return this.code ? capitalize(startCase(this.code)) : undefined;
  }
}
